import { Modal } from 'antd'
import React, { Dispatch, SetStateAction } from 'react'
type propsType = {
    isDeleteModalOpen: boolean;
    setIsDeleteModalOpen: Dispatch<SetStateAction<boolean>>;
    handleDelete: () => void;
    title: string;
}
const DeleteModal = ({ isDeleteModalOpen, setIsDeleteModalOpen, handleDelete, title }: propsType) => {
    return (
        <div>
            <Modal
                open={isDeleteModalOpen}
                title={null}
                keyboard
                onCancel={() => setIsDeleteModalOpen(false)}
                footer={null}
            >
                <div className="">
                    <h2 className="text-xl">Delete {title}</h2>
                    <p className='text-md mt-2'>Are you sure you want to delete?</p>

                    <div className="mt-8">
                        <div className="flex items-center space-x-4">
                            <button className="btn text-white bg-red-600" onClick={handleDelete}>Delete</button>
                            <button className="btn bg-gray-100" onClick={() => setIsDeleteModalOpen(false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default DeleteModal